/* global jQuery Swiper:false */

// session filter functionality
(function ($) {
	"use strict";

	$(".filter-link").on("click", function(event){
		// toggle display of filter link
		if ($(event.currentTarget).hasClass("active")) {
			$(event.currentTarget).removeClass("active");
		} else {
			$(event.currentTarget).addClass("active");
		}

		var filters = [];

		// create array of active filters
		$(".filter-link.active").each(function (index, element) {
			filters.push($(element).attr("data-filter-id"));
		});

		// hide all sessions
		$(".tab-content-wrapper tr").addClass("hidden");

		// show filtered sessions
		$(".tab-content-wrapper tr").each(function (index, element) {
			var filterId = $(element).attr("data-filter-id");

			if ($.inArray(filterId, filters) !== -1) {
				$(element).removeClass("hidden");
			}
		});
	});

	$(".clear-all a").on("click", function () {
		$(".filter-link").each(function (index, element) {
			$(element).removeClass("active");
			$(".tab-content-wrapper tr").removeClass("hidden");
		});
	});

}(jQuery));

// training agenda dropdown menu
(function($) {
	"use strict";

	// hide all class agendas
	$(".class").addClass("hidden");

	// if user clicks on class dropdown menu,
	$(".class-select").on("click", function (event) {
		event.stopPropagation();
		// open the dropdown menu
		$(event.currentTarget).find(".class-select-menu").removeClass("hidden");
	});

	$(".class-select-menu-item").on("click", function (event) {
		// hide all class agendas
		$(".class").addClass("hidden");

		// show selected class agenda
		var classNumber = $(event.currentTarget).attr("data-class");
		$("." + classNumber).removeClass("hidden");

		// close drop-down menu
		setTimeout(function () {
			$(".class-select-menu").addClass("hidden");
		}, 0);
	});

	// if user clicks anywhere, close dropdown menu
	$(document).on("click", function () {
		$(".class-select-menu").addClass("hidden");
	});
})(jQuery);

// expand / collapse session videos
(function($) {
	"use strict";

	$(document).ready(function () {
		// if user clicks on video type dropdown menu option,
		$("#session-videos .class-select").on("click", function (event) {
			event.stopPropagation();
			// open the dropdown menu
			$(event.currentTarget).find("#session-videos .class-select-menu").removeClass("hidden");
		});

		// if user clicks on video type dropdown menu option,
		$("#session-videos .class-select-menu-item").on("click", function (event) {
			// hide all video type containers
			$(".video-type-container").addClass("hidden");

			// show selected type of videos
			var videoType = $(event.currentTarget).attr("data-class");
			$(".video-type-container." + videoType).removeClass("hidden");

			if (videoType === "all") {
				$(".video-type-container").removeClass("hidden");
			}

			// close drop-down menu
			setTimeout(function () {
				$(".class-select-menu").addClass("hidden");
			}, 0);
		});

		// if user clicks anywhere, close dropdown menu
		$(document).on("click", function () {
			$(".class-select-menu").addClass("hidden");
		});
	});
})(jQuery);

// expand / collapse panelists
(function($) {
	"use strict";

	$(document).ready(function () {
		$(".panelists").addClass("hidden");

		if ($(".panelists-link").length > 0) {
			$(".panelists-link").on("click", function () {
				$(".panelists").slideToggle();
			});
		}
	});
})(jQuery);

(function () {
	// init home hero carousel
	new Swiper(".swiper-container-hero", {
		speed: 1500, 
		effect: 'fade',
		autoplay:true,
		loop:true, // Enable loop for continuous sliding
		fadeEffect: {
			crossFade: true,  // Enable crossFade for smoother transition
		 }
	});
})(jQuery);
